module.exports = __webpack_public_path__ + "img/education.1b1adff6.svg";